import service from '@/utils/server';
const modName='/purchOrder/whiteList/';

//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

//初始化更新对象
export const initUpdate = data => {
  return service({
    url: modName + 'editDetails',
    method: 'post',
    data
  });
};

//编辑提交
export const editData = data => {
  return service({
    url: modName + 'edit',
    method: 'post',
    data
  });
};
//新增提交
export const addData = data => {
  return service({
    url: modName + 'add',
    method: 'post',
    data
  });
};
//查询方法
export const addWhiteListPageInfo = data => {
  return service({
    url: modName + 'addWhiteListPageInfo',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/md/purchOrderWhiteList/api/index.js